<template>
<div class="chapter">
<div class="inner_page">
<div class="ident"><p class="nomcol"><i>A</i><span class="small">NCIENT</span> C<span class="small">HRISTIAN</span><br/>C<span class="small">OMMENTARY</span> <span class="small"><i>ON</i></span> S<span class="small">CRIPTURE</span></p><div class="fig" id="part1_fig0"><div class="imagelarge"><img alt="image" class="imagelarge" src="images/filet_ptit.jpg" width="500"/></div></div><p class="trad"><span>O<span class="small">LD</span> T<span class="small">ESTAMENT</span><br/>IV</span></p><div class="pagetitre"><a id="pagetitre"><p class="ident_tit"><span>J<span class="small">OSHUA</span>, J<span class="small">UDGES</span>, R<span class="small">UTH</span>,<br/>1-2 S<span class="small">AMUEL</span></span></p><p class="trad"><span>E<span class="small">DITED BY</span></span></p><div class="auteur_ident"><span>J<span class="small">OHN</span> R. F<span class="small">RANKE</span></span></div><div class="fig" id="part1_fig1"><div class="imagelarge"><img alt="image" class="imagelarge" src="images/filet_ptit.jpg" width="500"/></div></div><p class="trad"><span>G<span class="small">ENERAL</span> E<span class="small">DITOR</span><br/>T<span class="small">HOMAS</span> C. O<span class="small">DEN</span></span></p></a><div class="edit"><a id="pagetitre"></a><a class="url" href="http://www.ivpress.com/academic" target="_blank"><img alt="image" class="imagelarge_intext" id="logo" src="images/IVP_Academic_C.jpg" width="110"/></a></div></div></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ident1.vue?2b1659fb